<template>
    <div class="main-projects">
        <div class="row">
            
            <div class="col-lg-12">
                <div class="placeholder fit-content">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="enterprise.mainProjectType" />
                        Hvilke konkrete entrepriseopgaver tjenes der penge på?
                    </div>
                    <div class="placeholder">
                        
                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            v-if="!loading"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                                    {{ props.row.coverage_percent | coveragePercent }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'description'" class="table-column__description">
                                    <!--<d-tooltip placement="left" :space="true" :content="props.row.description" />-->
                                    {{ props.row.description }}
                                </div>
                                <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name">
                                    {{ props.row.name }}
                                </div>
                                <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer" :title="props.row.customer ? props.row.customer.name : '-'">
                                    <i class="fal fa-map-marker-alt" style="margin-left:2px;" v-tooltip="{
                                        content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
                                    }" v-if="props.row.installation_address"></i>
                                    {{ props.row.customer ? props.row.customer.name : '-' }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage'">
                                    <project-tooltip :project="props.row" />
                                    {{ props.row.coverage | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'invoices_total'">
                                    {{ props.row.invoices_total | currency }}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'external_created_at'">
                                    {{ props.row.external_created_at | moment("DD. MMM YYYY") }}
                                </div>
                                <div v-else-if="props.column.field == 'type.name'" class="table-column__description" :title="props.row.type ? props.row.type.name : '-'">
                                    {{ props.row.type ? props.row.type.name : '-' }}
                                </div>
                                <div v-else :title="props.formattedRow[props.column.field]">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                        <box-loading height="350" v-else />

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import * as mainProjectService from '@/services/mainProjectService'

export default {
    data () {
        return {
            loading: true,
            rows: [],
            columns: [
                { label: 'Ordre', field: 'case_number', type: 'number' },
                { label: 'Entreprisetype', field: 'type.name', type: 'string' },
                { label: 'Opgave', field: 'description', type: 'string', width: '20%' },
                { label: 'Kunde', field: 'customer.name', type: 'string' },
                { label: 'Startdato', field: 'external_created_at', type: 'string' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', width: '10%', type: 'number' },
                { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' },
                { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.$emit('finishedLoading', null)
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            mainProjectService.main(params, (response) => {
                this.rows = response.data
                this.loading = false
                this.$emit('finishedLoading', this.rows.length)
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// mainProjects.vue?520aba8f